import type { IconProps } from '.';

/**
 * Danger Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const DangerIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 13.5V21"
      stroke="#DFDFEC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0006 32.115H8.91063C3.70563 32.115 1.53063 28.395 4.05063 23.85L8.73063 15.42L13.1406 7.50004C15.8106 2.68504 20.1906 2.68504 22.8606 7.50004L27.2706 15.435L31.9506 23.865C34.4706 28.41 32.2806 32.13 27.0906 32.13H18.0006V32.115Z"
      stroke="#DFDFEC"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.9912 25.5H18.0047"
      stroke="#DFDFEC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DangerIcon;
